import lf from 'lovefield'

export function simu_engins (schemaBuilder) {
  schemaBuilder.createTable('simu_engins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('const_engins_id', lf.Type.INTEGER)
      .addColumn('reference', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true); // true == autoincrement
}

/*
CREATE TABLE IF NOT EXISTS `simu-engins` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `const-engins_id` int(11) NOT NULL,
  `reference` tinyint(4) NOT NULL,
  `coutfixe` float NOT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEngins.schema.js